<template>
    <div>
        <!-- 面包屑 -->
        <el-breadcrumb separator-class="el-icon-arrow-right"
                       style="font-size: 20px; padding: 20px 10px 20px; background-color: #e6e5e5;">
            <el-breadcrumb-item>Pharmacophore-Guided Molecular Generation</el-breadcrumb-item>
        </el-breadcrumb>
        <p class="content">Pharmacophore is defined as "an ensemble of steric and electronic features that is necessary to ensure
            the optimal supramolecular interactions with a specific biologic target and to trigger (or block) its biologic
            response [1]." Here, PGMG [2] provides a flexible strategy to generate bioactive molecules through the guidance of pharmacophore. The results demonstrate PGMG can generate
            bioactive molecules well in ligand-based and structure-based drug de novo design scenarios.
            <br>
            <br>
            Reference:
            <br>
            1. Wermuth, C. G., Ganellin, C. R., Lindberg, P., & Mitscher, L. A. (1998). Glossary of terms
            used in medicinal chemistry (IUPAC Recommendations 1998). Pure and applied Chemistry, 70(5), 1129-1143.
            <br>
<!--            2. Zhu H, Zhou R, Tang J, Li M. PGMG: A Pharmacophore-Guided Deep Learning Approach for-->
<!--            Bioactive Molecular Generation[J]. <i>arXiv preprint arXiv:2207.00821</i>, 2022.-->
            2. Zhu, H., Zhou, R., Cao, D., Tang, J., & Li, M. (2023). A pharmacophore-guided deep learning approach
            for bioactive molecular generation. Nature Communications, 14(1), 6234.
        </p>


        <!-- 表单 -->
        <phar-based-form></phar-based-form>
    </div>
</template>

<script>
    import PharBasedForm from "@/components/PharBasedForm";
    export default {
        name: "Submit",
        components: {
            PharBasedForm
        }
    }
</script>

<style scoped>
    div {
        max-width: 1160px;
        margin: 0 auto;
    }

    p {
        /*padding: 20px 0 20px;*/
        line-height: 1.5em;
        text-align: left;
    }

    .content{
        box-shadow: rgba(0, 0, 0, 0.02) 0px 1px 3px 0px, rgba(27, 31, 35, 0.15) 0px 0px 0px 1px;
        background-color: RGB(255,255,255);
        border-radius: 10px;
        padding: 10px;
    }
</style>